import { render, staticRenderFns } from "./SWysiwyg.vue?vue&type=template&id=2253d4f2"
import script from "./SWysiwyg.vue?vue&type=script&lang=js"
export * from "./SWysiwyg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports